export const DEFAULT_VALUE_FOR_IFRAME = 500
